(function () {
  if (!document.documentElement.classList.contains('callidus-offgrid-lead')) return;
  var pending = false;
  function visible(element) {
    return element.getClientRects().length > 0 && getComputedStyle(element).visibility !== 'hidden';
  }
  function releaseHiddenPromoLock() {
    pending = false;
    var body = document.body;
    if (!body || !body.classList.contains('klaviyo-prevent-body-scrolling')) return;
    var hiddenPromo = document.querySelector('[data-kl-scroll-locking-modal]:has([data-testid="klaviyo-form-QU5Z7T"]), [data-kl-scroll-locking-modal]:has([data-testid="klaviyo-form-V5VNAX"])');
    if (!hiddenPromo || visible(hiddenPromo)) return;
    var activeModal = Array.from(document.querySelectorAll('[role="dialog"][aria-modal="true"], dialog[open], #pandectes-banner')).some(visible);
    if (!activeModal) body.classList.remove('klaviyo-prevent-body-scrolling');
  }
  function schedule() {
    if (pending) return;
    pending = true;
    requestAnimationFrame(releaseHiddenPromoLock);
  }
  new MutationObserver(schedule).observe(document.body, {childList:true, subtree:true, attributes:true, attributeFilter:['class','style','open']});
  schedule();
})();
